import { render } from "./animation.vue?vue&type=template&id=4b470bd8&scoped=true"
import script from "./animation.vue?vue&type=script&lang=js"
export * from "./animation.vue?vue&type=script&lang=js"

import "./animation.vue?vue&type=style&index=0&id=4b470bd8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b470bd8"]])

export default __exports__